<template>
  <div
    class="position-relative composable-component-renderer-by-id"
    :class="{
      'hover-show-parent': !!recordId,
    }"
  >
    <AdminRoleOnly
      v-if="openBuilderEditHRef"
      class="position-absolute hover-show-target"
      style="
        top: -18px;
        right: 0;
        z-index: 1000;
        font-size: 11px;
        min-width: 100px;
        width: 100px;
      "
    >
      <a
        class="bg-white cursor-pointer border-rounded d-block"
        target="_blank"
        style="min-width: 100px; width: 100px; padding: 2px 1px 2px 4px"
        @click.prevent="() => openBuilderEditPage()"
      >
        <ficon type="edit" />
        Builderで編集</a
      >
    </AdminRoleOnly>
    <ComposableComponentRenderer
      :class="'composable-component-renderer-by-id'"
      v-if="initialized && builderData"
      :builderData="builderData"
    />
  </div>
</template>
<script lang="ts">
import { findStructureWithSharedComponentId } from '../../../../ComposableComponents/ComposableComponentInstanceItem'
import { openBuilderEditPage } from '../../../models/core_composable_component_definitions'

export default {
  name: 'ComposableComponentRendererById',
  props: {
    pageId: {
      type: String,
      required: false,
    },
    itemKey: {
      type: String,
      required: false,
    },
    sharedComponentId: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      initialized: false,
      builderData: null,
    }
  },
  computed: {
    openBuilderEditHRef() {
      if (this.recordId) {
        return `/#/composable-component-builder/${this.recordId}?sharedComponentId=${this.sharedComponentId}`
      } else if (this.itemKey) {
        return `/#/m/core_composable_component_definitions/new?key=${this.itemKey}&sharedComponentId=${this.sharedComponentId}`
      }
      return null
    },
    recordId() {
      return this.builderData?.id
    },
  },
  async created() {
    if (!this.pageId && !this.itemKey) {
      console.error(
        `[ComposableComponentRendererById] :pageId, :itemKey のどちらかを指定してください。`,
      )
      return
    }
    const data = await this.fetchAndExtractData()
    if (!data) {
      console.error(
        `[ComposableComponentRendererById] record not found, pageId: "${this.pageId}", itemKey: "${this.itemKey}"`,
      )
      return
    }
    this.builderData = JSON.parse(JSON.stringify(data))
    this.$nextTick(() => {
      this.initialized = true
    })
  },
  methods: {
    async fetchAndExtractData() {
      const data = await this.fetchData()
      if (!data) {
        return null
      }
      if (this.sharedComponentId) {
        // sharedComponentId を持つコンポーネントを探す
        const foundComponent = findStructureWithSharedComponentId(
          data.children,
          this.sharedComponentId,
        )
        // 強制的に表示状態に
        foundComponent._invisible = false
        if (foundComponent) {
          const id = crypto.randomUUID()
          return {
            id,
            key: id,
            children: [foundComponent],
          }
        }
      }
      return data
    },
    async fetchData() {
      const all = await $core.$models.core_composable_component_definitions.find({
        limit: -1,
      })
      if (this.pageId) {
        return all.find((d) => d.id === this.pageId)
      }
      if (this.itemKey) {
        return all.find((d) => d.key === this.itemKey)
      }
    },
    openBuilderEditPage() {
      openBuilderEditPage({
        id: this.pageId,
        key: this.itemKey,
        sharedComponentId: this.sharedComponentId,
      })
    },
  },
}
</script>
